import React from "react";
import { Redirect, } from "react-router-dom";

// --------------------------------------------------

export default class extends React.Component {
	state = {}

	login() {
		window.location = (
			"https://be.contentful.com/oauth/authorize"
			+ "?response_type=token"
			+ "&client_id=71fb718d84193d1c3d9df8185480a793908424d02578af23344636edeea3bdf1"
			+ "&redirect_uri=https://ruth-admin.dronz.co/token"
			+ "&scope=content_management_manage"
		);
	}

	render() {
		return (
			<div>
				<form
					onSubmit = { (e) => {
						e.preventDefault();
						console.log("submit");
						this.setState({ submitted: true, });
					}}
				>
					<input
						type = "text"
						placeholder = "Enter access token"
						onChange = { (e) => this.setState({ token: e.target.value, }) }
					/>
				</form>

				or

				<button
					onClick = { this.login }
				>
					Login
				</button>

				{
					this.state.submitted
					? <Redirect to = { `/token/#access_token=${this.state.token}` }/>
					: null
				}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Login.js